<template>
  <div class="CourseConfirmOrder">

    <Head :title="title"></Head>
    <!-- 主题部分 -->
    <div class="content">
      <!-- 商品名称 -->
      <div class="commodity_name">
        <div class="title">商品名称</div>
        <div class="contents">
          <div class="commodity_name_left">
            <img :src="information.pictureUrl" alt="" />
          </div>
          <div class="commodity_name_right">
            <p>{{ information.goodsName }}</p>
            <div class="introduction">
              <div class="details">{{ information.selectedText }}</div>
              <div class="number">×{{ information.selectedNum }}</div>
            </div>
            <div class="price">¥{{ totalPrice }}</div>
          </div>
        </div>
      </div>
      <div class="order-remark">
        <van-cell title="订单备注" is-link :value="remark !== '' ? remark : '无备注'"
          :value-class="remark !== '' ? 'cell-value' : ''" @click="openPopup('remark')" />
        <van-cell v-if="Number(totalPrice) > 0" title="发票" is-link
          :value="userInvoiceInfo.invoiceHeader ? userInvoiceInfo.invoiceHeader : '不开发票'" value-class="cell-value"
          @click="toInvoice()" />
      </div>
      <!-- 支付方式 -->
      <div class="payment" v-if="Number(totalPrice) > 0">
        <div class="title">支付方式</div>
        <van-radio-group v-model="radio" direction="horizontal">
          <div class="option">
            <div class="zhifubao">
              <img src="@/assets/mylogin/zhifubao-logo.png" alt="" />
              <div class="option_name">支付宝</div>
            </div>
            <van-radio name="1" style="margin-top: 18px"></van-radio>
          </div>
          <div class="option">
            <div class="weixin">
              <img src="@/assets/mylogin/weixinzhifu2@2x.png" alt="" />
              <div class="option_name">微信支付</div>
            </div>
            <van-radio name="2" style="margin-top: 18px"></van-radio>
          </div>
        </van-radio-group>
      </div>
      <van-action-sheet v-model="remarkPopupShow" title="备注">
        <div class="popup-content">
          <van-field @focus="handleElemInView" class="popup-input popup-textarea" v-model="remarkPopup" rows="8"
            type="textarea" maxlength="200" placeholder="请输入备注" show-word-limit />
          <van-button class="popup-btn" type="default" @click="confirmRemark()">确定</van-button>
        </div>
      </van-action-sheet>
    </div>
    <!-- 底部按钮 -->
    <div class="submit">
      <div class="money">¥{{ totalPrice }}</div>
      <van-button type="info" class="obt" @click="generate" :disabled="btnDisabled">提交订单</van-button>
    </div>
  </div>
</template>
  
<script>
import { Toast } from "vant";
import Head from "@/views/mobileView/My/components/headTabs.vue";
export default {
  name: "CourseConfirmOrder",
  components: {
    Head,
  },
  data() {
    return {
      title: "确认订单",
      radio: "1",
      information: {
        monographName: "",
        pictureUrl: "",
        selectedNum: "",
        selectedText: "",
        skuPrice: "",
      },
      courseList: [],
      // 生成订单的id
      payBatchId: "",
      btnDisabled: false, // 提交订单时禁用按钮，防止快速点击产生多比订单
      timer: null,
      // 备注弹窗参数
      remark: "",
      remarkPopupShow: false,
      remarkPopup: "",
      userInvoiceInfo: {}
    };
  },
  computed: {
    totalPrice() {
      return (
        (
          (this.information.skuPrice * 100 * this.information.selectedNum) /
          100
        ).toFixed(2) + ""
      );
    },
  },
  created() {
    this.userInvoiceInfo = sessionStorage.getItem("userInvoiceInfo") ? JSON.parse(sessionStorage.getItem("userInvoiceInfo")) : {};
    this.information = JSON.parse(localStorage.getItem("courseDetails"));
    this.courseList = JSON.parse(localStorage.getItem("courseParameter"));
  },
  methods: {
    toInvoice() {
      let query = {
        from: 'orderConfirm',
      }
      this.$router.push({ path: '/invoice', query })
    },
    // 生成订单
    async generate() {
      this.btnDisabled = true
      let obj = {
        list: this.courseList,
        originProject: "information",
      }
      if (sessionStorage.getItem("userInvoiceInfo")) {
        let userInvoiceInfo = JSON.parse(sessionStorage.getItem("userInvoiceInfo"))
        let userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
        userInvoiceInfo.invoicePrice = this.totalPrice
        userInvoiceInfo.userId = userInfo.user.id
        obj.userInvoiceInfo = userInvoiceInfo
      }
      if (this.remark !== '') obj.remark = this.remark
      const resp = await this.$apis.paymentServe.generate(obj);
      if (resp.resultCode === "200") {
        this.payBatchId = resp.data.payBatchid;
        if (resp.data.payStatus == 0) {
          // 免费商品，不需要调支付接口，直接生成订单跳转订单列表或者详情
          this.$router.push({ path: "/orders" });

        } else {
          this.$router.replace({
            path: "/orderDetails",
            query: { id: resp.data.payBatchid, isPrimaryOrder: true, payType: this.radio, createTime: resp.data.createTime },
          });
          // 付费商品，根据支付方式唤起银联支付
          // if (this.radio === "1") {
          //   this.zhifubaoGetPay();
          // } else {
          //   this.weixinGetPay();
          // }
        }
      } else {
        Toast(resp.resultDesc);
        this.btnDisabled = false
      }
    },
    // 银联支付宝
    async zhifubaoGetPay() {
      const resp = await this.$apis.paymentServe.getPay({
        payBatchId: this.payBatchId,
        payType: "h5_ali",
      });
      if (resp.resultCode === "200") {
        location.href = resp.data;
        this.timer = setTimeout(() => {
          this.btnDisabled = false
        }, 3000)
      } else {
        this.btnDisabled = false
      }

    },
    // 银联微信接口
    async weixinGetPay() {
      const resp = await this.$apis.paymentServe.getPay({
        merAppId: this.$global.zhifu,
        payBatchId: this.payBatchId,
        payType: "h5_wx",
        sceneType: this.$global.isAndroid_ios() ? "IOS_WAP" : "AND_WAP",
      });
      if (resp.resultCode === "200") {
        location.href = resp.data;
        this.timer = setTimeout(() => {
          this.btnDisabled = false
        }, 3000)
      } else {
        this.btnDisabled = false
      }
    },
    // 打开填写信息弹窗
    openPopup(name) {
      this[`${name}Popup`] = this[name]
      this[`${name}PopupShow`] = true
    },
    // 备注弹窗确认
    confirmRemark() {
      this.remark = this.remarkPopup
      this.remarkPopupShow = false
    },
    // 确保输入框不被软键盘遮挡 处理ios16问题
    handleElemInView(e) {

      window.scrollTo(0, window.innerHeight - 375);
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'courseDetails' || to.name === 'tobepaid' || to.name === 'orders') {
      sessionStorage.removeItem("userInvoiceInfo");
      //清除定时器
      clearInterval(this.timer);
      this.timer = null;
    }
    next()
  },
};
</script>
  
<style lang="scss" scoped>
.CourseConfirmOrder {
  width: 100vw;
  min-height: 100vh;
  background: #f5f5f5;

  .content {
    margin: 12px;

    .commodity_name {
      padding: 12px;
      margin-bottom: 12px;
      background: #fff;
      border-radius: 8px;
      // height: 145px;

      .title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
      }

      .contents {
        display: flex;
        margin-top: 15px;

        .commodity_name_left {
          width: 80px;
          height: 80px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .commodity_name_right {
          margin-left: 10px;

          p {
            width: 250px;
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 23px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }

          .introduction {
            display: flex;
            margin-top: 8px;
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 21px;

            .details {
              width: 220px;
            }
          }

          .price {
            margin-top: 8px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 17px;
          }
        }
      }
    }

    .order-remark {
      margin-top: 12px;
      padding: 5px 0;
      width: 100%;
      background-color: #fff;
      border-radius: 8px;
      overflow: hidden;

      .cell-value {
        font-size: 14px;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .payment {
      margin-top: 12px;
      padding: 12px;
      background: #fff;
      border-radius: 8px;

      .title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
      }

      .option {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        height: 80px;

        ::v-deep.van-radio__icon--checked .van-icon {
          background-color: #4a79f1;
          border-color: #4a79f1;
        }

        .zhifubao {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          img {
            width: 30px;
            height: 30px;
          }

          .option_name {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 21px;
            margin-left: 15px;
            width: 250px;
          }

          .img-icon {
            width: 20px;
            height: 20px;
          }
        }

        .weixin {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          img {
            width: 30px;
            height: 30px;
          }

          .option_name {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 21px;
            margin-left: 15px;
            width: 250px;
          }

          .img-icon {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }

  .popup-content {
    margin: 25px 25px 5px;

    .popup-input {
      margin-bottom: 55px;
      background-color: #f5f5f5;
      border-radius: 8px;
    }

    .popup-textarea {
      margin-bottom: 19px;
    }

    .popup-btn {
      width: 100%;
      height: 44px;
      background-color: #4A79F1;
      border-radius: 22px;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 44px;
    }
  }

  .submit {
    width: 100%;
    margin: 0px;
    position: fixed;
    bottom: 0px;
    height: 49px;
    background: #fff;
    display: flex;
    padding: 0px 0px 0px 15px;

    .money {
      font-size: 21px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff3d3d;
      line-height: 17px;
      width: 190px;
      margin-top: 10px;
      margin-top: 16px;
    }

    .obt {
      width: 160px;
      height: 44px;
      border-radius: 22px;
      margin-top: 3px;
      margin-right: 15px;
    }
  }
}
</style>